module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weather-station"
  }, [_c('div', {
    staticClass: "tip-text"
  }, [_vm._v("气象站")]), _vm._v(" "), _c('div', {
    staticClass: "station-name"
  }, [_vm._v(_vm._s(_vm.stationName))]), _vm._v(" "), _c('div', {
    staticClass: "station-select"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.activeStationID),
      callback: function($$v) {
        _vm.activeStationID = $$v
      },
      expression: "activeStationID"
    }
  }, _vm._l((_vm.stationList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.StationName,
        "value": item.StationID
      }
    })
  }))], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-ece84412", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ece84412"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/weatherInfo/weather-station.vue
// module id = 1085
// module chunks = 1